// eslint-disable-next-line import/no-extraneous-dependencies
import { createTheme, createVariant } from '@clds/component-theme';
export const listTheme = createTheme({
    byMaxHeight: {
        md: { maxHeight: '300px' },
        lg: { maxHeight: '420px' },
        none: { maxHeight: 'none' },
    },
}, 'list');
export const popoverMaxHeightVariant = createVariant(
// eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
(props) => listTheme.byMaxHeight[props.maxHeight || 'none']);
//# sourceMappingURL=theme.js.map